import React, { Component } from 'react';
import { reduxForm} from 'redux-form';import { connect } from 'react-redux';
import { CommonButton } from '../../../../../components/buttons';
import UploadTargetModal from './UploadTargetModal';
import UploadBehaviorModal from './UploadBehaviorModal';
const validate = (values) => {
    const errors = {};
    
    return errors;
  };

  
class UploadBehavior extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDownloadTargetModal:false,
            isOpenUploadBehaviorModal: false,
            isOpenDownloadBehaviorsForRawDataModal: false,
            uploadCSVDocumentObj: null,
        }
    }

   openDownloadTargetModalHandler = () => {
    this.setState({openDownloadTargetModal:true})
   }

   closeDownloadTargetModalHandler = () => {
    this.setState({openDownloadTargetModal:false})
   }

   openUploadBehaviorModalHandler = () => {
    this.setState({isOpenUploadBehaviorModal:true})
   }

   closeUploadBehaviorModalHandler = () => {
    this.setState({isOpenUploadBehaviorModal:false})
   }


    render() {
        const { handleSubmit } = this.props;
        return (
            <div className="row">
                <div className="panel_title">
                    <em>{this.props.title}</em>
                </div>
                <div className="col-sm-12">
                    <div>
                        <CommonButton className="mt-10" label="Upload New Targets" primary={true} onTouchTap={this.openDownloadTargetModalHandler} />
                    </div>
                    <div>
                        <CommonButton className="mt-10" label="Upload New Behaviors" primary={true} onTouchTap={this.openUploadBehaviorModalHandler} />
                    </div>
                    <div>
                        {this.state.openDownloadTargetModal?
                          <UploadTargetModal
                          documentHandler={this.props.documentHandler}
                          dialogTitle={this.props.dialogTitle}
                          uploadCSVDocumentObj={this.state.uploadCSVDocumentObj}
                          closeDialog = {this.closeDownloadTargetModalHandler}
                          />:
                          null
                        }
                        {this.state.isOpenUploadBehaviorModal?
                          <UploadBehaviorModal
                          documentHandler={this.props.uploadBehaviorHandler}
                          dialogTitle={'upload new behaviors'}
                          uploadCSVDocumentObj={this.state.uploadCSVDocumentObj}
                          closeDialog = {this.closeUploadBehaviorModalHandler}
                          />:
                          null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

//const selector = formValueSelector('PatientMasterCriteriaForm');
const mapStateToProps = (state, ownProps) => {
    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_MASTERY_CRITERIA")[0].permission : false;

    return {
        addPermission: addPermission,
        downloadTargetReducer: state.downloadTargetReducer
    };
};

UploadBehavior = reduxForm({
    form: 'UploadBehavior', 
    validate,
    enableReinitialize: true,
})(UploadBehavior);


export default connect(mapStateToProps, {})(UploadBehavior);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downloadTargets/UploadBehavior.js